import React from 'react';
import { IconProps } from '../types';

export const Telegram = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8.75534L5.60763 13.5513C5.60763 13.5513 5.80863 14 6.02385 14C6.23908 14 9.44022 10.4107 9.44022 10.4107L13 3L4.05736 7.51735L4 8.75534Z"
        filter={'brightness(0.6)'}
        fill="currentColor"
      />
      <path
        d="M6.33083 10L6.00569 13.5206C6.00569 13.5206 5.86959 14.5993 6.92817 13.5206C7.98675 12.4418 9 11.61 9 11.61"
        filter={'brightness(0.8)'}
        fill="currentColor"
      />
      <path
        d="M3.68794 8.99463L0.300354 7.92419C0.300354 7.92419 -0.104499 7.7649 0.0258633 7.40367C0.0526993 7.32918 0.106834 7.2658 0.268775 7.15687C1.01937 6.64947 14.1617 2.06829 14.1617 2.06829C14.1617 2.06829 14.5328 1.94702 14.7517 2.02768C14.8058 2.04394 14.8545 2.07385 14.8928 2.11435C14.9311 2.15486 14.9577 2.2045 14.9697 2.25822C14.9933 2.35309 15.0032 2.45069 14.9991 2.54821C14.998 2.63257 14.9875 2.71076 14.9795 2.83337C14.8995 4.08589 12.5041 13.4338 12.5041 13.4338C12.5041 13.4338 12.3608 13.9808 11.8474 13.9995C11.7212 14.0035 11.5955 13.9827 11.4777 13.9386C11.36 13.8944 11.2526 13.8277 11.162 13.7424C10.1544 12.9018 6.6717 10.6319 5.90214 10.1327C5.88478 10.1212 5.87016 10.1063 5.85926 10.0889C5.84837 10.0715 5.84145 10.052 5.83898 10.0318C5.82822 9.97914 5.88722 9.91397 5.88722 9.91397C5.88722 9.91397 11.9515 4.68628 12.1128 4.13749C12.1253 4.09497 12.0781 4.074 12.0147 4.09262C11.612 4.23632 4.62974 8.51259 3.85913 8.98454C3.80366 9.00081 3.74503 9.00427 3.68794 8.99463Z"
        fill="currentColor"
      />
    </svg>
  );
};
